// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_6m-0";
export var optionCard = "_6m-1";